import { render } from "./About.vue?vue&type=template&id=96cc0c48"
const script = {}

import exportComponent from "/builds/lukas/lukasrunge.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__